import type { ISeriesWithEvents } from '@/types/series.types';
import { GetJson as Get } from '../helpers';
import { SeriesPath } from './path';

export default function LoadSeriesFullByEventUuid({ channel, eventUuid }: { channel: number; eventUuid: string }) {
	return Get<ISeriesWithEvents>({
		path: SeriesPath(channel, `/event/${eventUuid}`),
	});
}
